import { useLayoutEffect, useRef } from 'react';

import type { Entry, Side } from '../types';

const byId = new Map<string, Entry>();

export const useRegisterCaseCardAnchor = (caseId: string, side?: Side) => {
  const ref = useRef<HTMLDivElement | null>(null);
  useLayoutEffect(() => {
    if (ref.current) {
      byId.set(caseId, { el: ref.current, side });
    }

    return () => {
      byId.delete(caseId);
    };
  }, [caseId, side]);
  return ref;
};
export const getCardAnchor = (caseId: string): Entry | null => {
  const entry = byId.get(caseId);
  return entry ?? null;
};
export const getCardAnchors = (): Entry[] => Array.from(byId.values());
